<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-row>
        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Location ID"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="query.locationID"
              label="Location ID"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>


        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Appointment SLA"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="appointmentSla"
              label="Appointment SLA"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="query.appointmentSla"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Demand Type"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="demandType"
              label="Demand Type"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="query.demandType"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Appointment Slot Type"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="appointmentSlotType"
              label="Appointment Slot Type"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="query.appointmentSlotType"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Start DateTime"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <date-picker v-model="dateTimeRange" type="datetime" range placeholder="Select Appointment datetime range"></date-picker>
          </ValidationProvider>
        </v-col>


      </v-row>

      <div class="text-right mb-7">
        <v-btn
          class="primary"
          @click="submit"
        >Submit</v-btn
        >
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "query-available-slots",
  components: { DatePicker },
  data: () => ({
    query:{},
    appointmentSla:[
      { text: "Standard", value: "Standard", disabled: false },
      { text: "Accelerated", value: "Accelerated", disabled: false },
    ],
    demandType:[
      { text: "Standard Install", value: "Standard Install", disabled: false },
      { text: "Additional Install", value: "Additional Install", disabled: false },
      { text: "Non EU Jumper Only", value: "Non EU Jumper Only", disabled: false },
      { text: "Service Restoration", value: "Service Restoration", disabled: false },
    ],
    appointmentSlotType:[
      { text: "AM", value: "AM", disabled: false },
      { text: "PM", value: "PM", disabled: false },
      { text: "AHA", value: "AHA", disabled: false },
    ],
    dateTimeRange:null,
  }),
  methods:{
    submit() {
      let vm = this;
      let payload = {};
      payload = {
        locationId:vm.query.locationID,
        demandType:vm.query.demandType.value,
        priId:null,
        alternativeTechnology:null,
        appointmentId:null,
        copperPairId:null,
        appointmentSLA:vm.query.appointmentSla.value,
        appointmentSlotType:vm.query.appointmentSlotType.value,
        priorityAssist:"No",
        // serviceRestorationSLA:null,
        nBNReferenceID:null,
        startDateTime:vm.dateTimeRange[0],
        endDateTime:vm.dateTimeRange[1]
      };

      vm.checkNbnAvailableSlots(payload).then((data) => {
        vm.$emit("showSlotsResultSection", data);
      });
    }
  }
}
</script>

<style scoped>

</style>
